var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c(
        "base-modal-ex",
        {
          attrs: {
            active: _vm.isActive,
            "animation-in": _vm.animationIn,
            "animation-out": _vm.animationOut,
            "animation-duration": _vm.animationDuration,
            "can-cancel": false,
            "min-width": _vm.width,
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isActive = $event
            },
          },
        },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c(
              "div",
              {
                staticClass: "modal-card-title",
                class: { "is-flex-items-center": _vm.showIcon },
              },
              [
                _vm.showIcon
                  ? _c(
                      "span",
                      {
                        staticClass: "icon is-medium",
                        class: `has-text-${_vm.iconType}`,
                        staticStyle: { "margin-right": "0.5rem" },
                      },
                      [
                        _c("i", {
                          staticClass: "mdi mdi-36px",
                          class: `${_vm.iconName}`,
                        }),
                      ]
                    )
                  : _vm._e(),
                _c("span", [_vm._v(_vm._s(_vm.title))]),
              ]
            ),
          ]),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [
              _vm.value && _vm.imageSelectPage
                ? _c("image-select", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.imageSelectPage.show,
                        expression: "imageSelectPage.show",
                      },
                    ],
                    attrs: {
                      "quote-id": _vm.value.quoteId,
                      "pre-select": "NotSent",
                    },
                    model: {
                      value: _vm.selectedImageIds,
                      callback: function ($$v) {
                        _vm.selectedImageIds = $$v
                      },
                      expression: "selectedImageIds",
                    },
                  })
                : _vm._e(),
              _vm.value && _vm.submitPage
                ? _c("div", [
                    _vm.modalType === "SendInvoice"
                      ? _c(
                          "div",
                          [
                            _c(
                              "notification-box",
                              {
                                staticClass: "mb-3",
                                attrs: { type: "warning" },
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass: "is-size-6",
                                    attrs: { slot: "text-content" },
                                    slot: "text-content",
                                  },
                                  [
                                    _vm._v(
                                      "After invoice is submitted, set timeline in EstImage to send for approval."
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c("div", { staticClass: "field" }, [
                              _c("label", { staticClass: "label" }, [
                                _vm._v("Select an invoice to send:"),
                              ]),
                              _c(
                                "ul",
                                { staticClass: "control" },
                                _vm._l(_vm.taxInvoice, function (invoice) {
                                  return _c(
                                    "li",
                                    {
                                      key: invoice.invoiceId,
                                      staticClass:
                                        "mt-2 pretty p-default p-round p-smooth",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.selectedInvoice,
                                            expression: "selectedInvoice",
                                          },
                                        ],
                                        attrs: {
                                          id: "chk-pretty-excess-type",
                                          name: "chk-pretty-excess-type",
                                          type: "radio",
                                        },
                                        domProps: {
                                          value: invoice.invoiceId,
                                          checked: _vm._q(
                                            _vm.selectedInvoice,
                                            invoice.invoiceId
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.selectedInvoice =
                                              invoice.invoiceId
                                          },
                                        },
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "state p-primary" },
                                        [
                                          _c("label", [
                                            _vm._v(_vm._s(invoice.invoiceNo)),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm.modalType === "SendQuoteWithConfirm" &&
                        _vm.submitPage.show
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "field" },
                            [
                              _c(
                                "notification-box",
                                {
                                  staticClass: "mb-3",
                                  attrs: { type: "warning" },
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "is-size-6",
                                      attrs: { slot: "text-content" },
                                      slot: "text-content",
                                    },
                                    [
                                      _c("b", [_vm._v("Remember:")]),
                                      _vm._v(
                                        " Send quote from EstImage to complete this process."
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c("p", [
                                _vm._v(
                                  "You are about to submit items to EstImage. Once items have been submitted changes can only be made by creating a supplementary."
                                ),
                              ]),
                              _c("p", [
                                _vm._v(
                                  "Please review all details carefully to ensure accuracy before proceeding."
                                ),
                              ]),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _c(
            "footer",
            {
              staticClass: "modal-card-foot",
              style: `justify-content: flex-${_vm.buttonLocation}`,
            },
            [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeComponent > 0,
                      expression: "activeComponent > 0",
                    },
                  ],
                  staticClass: "button is-success tooltip",
                  attrs: { "data-tooltip": "Previous" },
                  on: {
                    click: function ($event) {
                      return _vm.previous()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon is-small" }, [
                    _c("i", { staticClass: "mdi mdi-24px mdi-chevron-left" }),
                  ]),
                ]
              ),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.activeComponent < _vm.componentStatuses.length - 1,
                      expression:
                        "activeComponent < componentStatuses.length - 1",
                    },
                  ],
                  staticClass: "button is-success tooltip",
                  attrs: { "data-tooltip": "Next" },
                  on: {
                    click: function ($event) {
                      return _vm.next()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon is-small" }, [
                    _c("i", { staticClass: "mdi mdi-24px mdi-chevron-right" }),
                  ]),
                ]
              ),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.activeComponent ===
                        _vm.componentStatuses.length - 1,
                      expression:
                        "activeComponent === componentStatuses.length - 1",
                    },
                  ],
                  staticClass: "button is-success tooltip",
                  attrs: {
                    "data-tooltip": "Submit",
                    disabled: _vm.isSubmitDisabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon is-small" }, [
                    _c("i", { staticClass: "mdi mdi-18px mdi-send" }),
                  ]),
                  _c("span", [_vm._v("Submit")]),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "button tooltip",
                  attrs: {
                    "data-tooltip": "Cancel",
                    disabled: _vm.cancelDisabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_c("span", [_vm._v("Cancel")])]
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }